import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 7H16.5V6.75C16.5 5.23122 15.2688 4 13.75 4H9.75C8.23122 4 7 5.23122 7 6.75V7H4.25C3.00736 7 2 8.00736 2 9.25V10.5969C4.49546 12.2135 8.03112 13.25 12 13.25C15.7107 13.25 19.0427 12.3439 21.5 10.9048V9.25C21.5 8.00736 20.4926 7 19.25 7ZM21.5 12.6153C18.8753 13.9623 15.5648 14.75 12 14.75C8.20485 14.75 4.69804 13.8573 2 12.3473V17.25C2 18.4926 3.00736 19.5 4.25 19.5H19.25C20.4926 19.5 21.5 18.4926 21.5 17.25V12.6153ZM15 6.75V7H8.5V6.75C8.5 6.05964 9.05964 5.5 9.75 5.5L13.75 5.5C14.4404 5.5 15 6.05964 15 6.75Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
